import { type Quote } from '../../../modules/quotes'
import bestViewHandler from './viewHandlers/best.viewHandler'
import cheapestViewHandler from './viewHandlers/cheapest.viewHandler'
import bestRatedViewHandler from './viewHandlers/bestRated.viewHandler'
import { QuotesView } from './quotesView.types'
import { type Move } from '../../../modules/moves'

const localstorageKey = 'quotesView'

const viewHandlerFactory = (view: QuotesView) => {
  switch (view) {
    case QuotesView.best:
      return bestViewHandler
    case QuotesView.bestRated:
      return bestRatedViewHandler
    case QuotesView.cheapest:
    default:
      return cheapestViewHandler
  }
}

/**
 * get current quotes view
 */
export const useDefaultQuotesView = (move: Move) => {
  const savedValue = localStorage.getItem(localstorageKey)
  if (savedValue) {
    return savedValue as QuotesView
  }
  const isDateFlexible = move.jobs.every(job => !!job.dateTime.flexibleDate)
  return isDateFlexible ? QuotesView.best : QuotesView.cheapest
}

/**
 * change quotes view
 */
export const useSaveQuotesViewAction = () => {
  return (quotesView: QuotesView) => {
    localStorage.setItem(localstorageKey, quotesView)
  }
}

/**
 * returns sorted quotes
 */
export const useSortedQuote = (quotes: Quote[], view: QuotesView) => {
  return viewHandlerFactory(view).sort([...quotes])
}
